import account from './endpoints/account'
import additional from './endpoints/additional'
import animalfeed from './endpoints/animalfeed'
import animaltypes from './endpoints/animaltypes'
import companies from './endpoints/companies'
import dashboard from './endpoints/dashboard'
import deliveries from './endpoints/deliveries'
import employees from './endpoints/employees'
import farms from './endpoints/farms'
import groups from './endpoints/groups'
import history from './endpoints/history'
import ingredients from './endpoints/ingredients'
import ingredienttypes from './endpoints/ingredienttypes'
import loadings from './endpoints/loadings'
import local from './endpoints/local'
import mixers from './endpoints/mixers'
import permissions from './endpoints/permissions'
import rations from './endpoints/rations'
import recipes from './endpoints/recipes'
import reports from './endpoints/reports'
import schedule from './endpoints/schedule'
import stocks from './endpoints/stocks'
import leftovers from './endpoints/leftovers'

export default {
  account,
  additional,
  animalfeed,
  animaltypes,
  companies,
  dashboard,
  deliveries,
  employees,
  farms,
  groups,
  history,
  ingredients,
  ingredienttypes,
  loadings,
  local,
  mixers,
  permissions,
  rations,
  recipes,
  reports,
  schedule,
  stocks,
  leftovers
}
